import { render, staticRenderFns } from "./placard_media_view.vue?vue&type=template&id=41a89a52&scoped=true"
import script from "./placard_media_view.vue?vue&type=script&lang=js"
export * from "./placard_media_view.vue?vue&type=script&lang=js"
import style0 from "./placard_media_view.vue?vue&type=style&index=0&id=41a89a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a89a52",
  null
  
)

export default component.exports